import React from "react"
import {AllowedDepositProductsColumns, DepositProductsColumns} from "./DepositProducts.types"
import {DepositProduct} from "../../resources/depositProduct"
import {Resource} from "../../resources/common"
import {useNavigateWithListPath} from "../../hooks/useListReturnPath"
import {ReactElement} from "react"
import {DataTableCell, DataTableRow} from "../DataTable/DataTable"
import classNames from "classnames"
import {OrgName} from "../OrgName/OrgName"
import {BankName} from "../BankName/BankName"
import moment from "moment"
import IdLink from "../IdLink/IdLink"

interface DepositProductsRowProps {
	depositProduct: DepositProduct
	include?: Resource[]
	showOrgColumn?: boolean
	includedColumns: Array<AllowedDepositProductsColumns>
	refresh?: () => void
}

export default function DepositProductRow({depositProduct, include, includedColumns}: DepositProductsRowProps) {
	const navigateWithListPath = useNavigateWithListPath()

	const contentColumns: Partial<Record<AllowedDepositProductsColumns, ReactElement>> = {}

	if (includedColumns.includes(DepositProductsColumns.id)) {
		contentColumns["Id"] = (
			<DataTableCell className={classNames("data-table-id-cell")}>
				<IdLink className="data-table-id" href={`/deposit-products/${depositProduct.id}`}>
					{depositProduct.id}
				</IdLink>
			</DataTableCell>
		)
	}

	if (includedColumns.includes(DepositProductsColumns.status) && depositProduct.attributes.status == "Disabled") {
		contentColumns["Status"] = (
			<DataTableCell>
				<div className="deposit-products-status"> {depositProduct.attributes.status} </div>
			</DataTableCell>
		)
	} else {
		contentColumns["Status"] = <DataTableCell> </DataTableCell>
	}

	if (includedColumns.includes(DepositProductsColumns.org)) {
		if (depositProduct?.relationships?.org) {
			contentColumns["Org"] = <OrgName orgId={depositProduct.relationships.org.data.id} included={include} />
		} else {
			contentColumns["Org"] = <DataTableCell> -- </DataTableCell>
		}
	}

	if (includedColumns.includes(DepositProductsColumns.name)) {
		contentColumns["Name"] = <DataTableCell>{depositProduct.attributes.name}</DataTableCell>
	}

	if (includedColumns.includes(DepositProductsColumns.bank)) {
		if (depositProduct?.relationships?.bank) {
			contentColumns["Bank"] = (
				<DataTableCell>
					<BankName bankId={depositProduct.relationships.bank.data.id} included={include} />
				</DataTableCell>
			)
		} else if (depositProduct.attributes.bankName) {
			contentColumns["Bank"] = <DataTableCell>{depositProduct.attributes.bankName}</DataTableCell>
		} else {
			contentColumns["Bank"] = <DataTableCell> -- </DataTableCell>
		}
	}

	if (includedColumns.includes(DepositProductsColumns.createdAt)) {
		contentColumns["Created At"] = (
			<DataTableCell>{moment(depositProduct.attributes.createdAt).format("L")}</DataTableCell>
		)
	}

	const content: Array<ReactElement | null> = []

	includedColumns.forEach((col, i) => {
		if (col in contentColumns && contentColumns[col]) {
			const column = {...contentColumns[col]} as ReactElement
			column.key = i.toString()
			content.push(column)
		}
	})

	return (
		<DataTableRow
			onClick={(e) => {
				e.preventDefault()
				e.stopPropagation()
				navigateWithListPath(`/deposit-products/${depositProduct.id}`)
			}}
		>
			{content}
		</DataTableRow>
	)
}
